import request from '../../../services/request';
export var getDeliveryLocations = function getDeliveryLocations(sku) {
  return request("https://delivery.products.cimpress.io/v1/deliverylocations/" + sku);
};